(function(){
'use strict';

angular.module('classy.frs').component('registrationCartList', {
  template: '\n      <div class="registration-cart__items"\n        ng-class="{ \'is-staged\': !$ctrl.cart.isReserved }">\n\n        <!-- Team -->\n        <div class="registration-cart__item"\n          ng-if="$ctrl.showTeam()"\n          ng-style="{ color: $ctrl.color }">\n\n          <registration-cart-item\n            item-name="$ctrl.teamName()"\n            item-details="$ctrl.teamDetails()"\n            is-removable="false"\n            on-remove="$ctrl.removeTeam()"\n          ></registration-cart-item>\n        </div>\n\n\n        <!-- Tickets -->\n        <div class="registration-cart__item"\n             ng-repeat="item in $ctrl.itemCollection() track by $index"\n             ng-class="{ highlighted: $ctrl.itemHighlighted(item) }"\n             ng-style="{ color: $ctrl.color }">\n\n          <registration-cart-item\n            item-name="$ctrl.itemName(item)"\n            item-price="$ctrl.itemPrice(item) | currency:\'$\':2"\n            item-details="$ctrl.itemDetails(item)"\n            item-commitment="$ctrl.itemCommitment(item)"\n            sub-items="$ctrl.itemAttendees($index)"\n            go-to-subitem="$ctrl.goToSubitem($index, regIdx, event)"\n            on-click="$ctrl.goToAttendee(item)"\n            is-removable="$ctrl.canRemoveItem()"\n            on-remove="$ctrl.removeItem(item, event, $index)"\n            group-size="$ctrl.cart.attendeeIndices[$index]"\n            adjustment-amount="$ctrl.getAdjustedAmount(item)"\n            has-promo-code="item.adjustment_amount"\n            lock-clicking="$ctrl.questionLock(item)">\n          </registration-cart-item>\n\n        </div>\n        <!-- Donation -->\n        <div class="registration-cart__item"\n          ng-if="$ctrl.cart.current.donation_amount"\n          ng-class="{ highlighted: $ctrl.donationHighlighted() }"\n          ng-style="{ color: $ctrl.color }">\n\n          <registration-cart-item\n            item-name="\'Additional Donation\'"\n            item-price="$ctrl.donationAmount() | currency:\'$\':2"\n            item-details="$ctrl.donationDetails()"\n            on-click="$ctrl.goToDonation()"\n            is-removable="$ctrl.canRemoveDonation()"\n            on-remove="$ctrl.removeDonation()">\n          </registration-cart-item>\n\n        </div>\n\n        <!-- Donation Fees -->\n        <div class="registration-cart__item" ng-if="$ctrl.cart.donationFeeOnTop() && $ctrl.donationFees() > 0">\n          <registration-cart-item\n            item-name="\'Donation Fees\'"\n            item-price="$ctrl.donationFees() | currency:\'$\':2"\n            item-price-calculating="$ctrl.calculatingFees()"\n            item-details="\'Thanks for covering the fees!\'"\n            on-click="$ctrl.goToDonation()"\n            is-removable="false"\n            on-remove="$ctrl.removeFot()">\n          </registration-cart-item>\n\n        </div>\n      </div>\n    ',
  bindings: {
    cart: '=',
    color: '<?'
  },

  controller: ["$state", "$scope", "scFlowModalService", "scCampaignsService", "scThemesService", "scCurrencyService", "registrationNavigator", "registrationRoutes", "scAnalytics", function registrationCartList($state, $scope, scFlowModalService, scCampaignsService, scThemesService, scCurrencyService, registrationNavigator, registrationRoutes, scAnalytics) {
    var _this2 = this;

    var DEFAULTS = {
      color: scThemesService.active.current.styles.primaryColor
    };

    var TICKETS_ROUTE = registrationRoutes.TICKETS_ROUTE,
        ATTENDEE_ROUTE = registrationRoutes.ATTENDEE_ROUTE,
        NEW_ATTENDEE_ROUTE = registrationRoutes.NEW_ATTENDEE_ROUTE,
        DONATION_ROUTE = registrationRoutes.DONATION_ROUTE,
        PAYMENT_ROUTE = registrationRoutes.PAYMENT_ROUTE;


    this.$onInit = function () {
      var _this = this;

      _.defaultsDeep(this, DEFAULTS);

      /* -------------------------------------------------------------------- *
       * Fees
       * -------------------------------------------------------------------- */

      this.donationFees = function () {
        return _this.cart.donationFees;
      };
      this.registrationFees = function () {
        return _this.cart.serviceFees;
      };
      this.calculatingFees = function () {
        return _this.cart.isCalculating;
      };
      this.HAS_FUNDRAISING = scCampaignsService.active.HAS_FUNDRAISING;
      this.questions = scCampaignsService.active.current.questions;
      this.ticketTypes = scCampaignsService.active.current.ticketTypes;

      // Initializes the attendeeIndices model in the event that we are refreshing a
      // page in the checkout flow and the cart exists.
      if (!$state.is(TICKETS_ROUTE)) {
        this.cart.attendeeIndices = [];

        var items = this.itemCollection();
        items.forEach(function (item, index) {
          var itemEntries = item.entries || item.registrants.length;

          if (index == 0) {
            _this.cart.attendeeIndices.push(itemEntries);
            return;
          }

          var totalEntries = _this.cart.attendeeIndices[index - 1] || 0;
          _this.cart.attendeeIndices.push(itemEntries + totalEntries);
        });
      }
    };

    this.addSubItem = function (sum, n) {
      var additional = sum + n;
      _this2.cart.attendeeIndices.push(additional);
      return additional;
    };

    this.removeSubItem = function (sum, n) {
      return sum - n;
    };

    /* -------------------------------------------------------------------- *
     * Navigation
     * -------------------------------------------------------------------- */

    this.goToAttendee = function (cartItem) {
      // Only enable click if all attendees have been filled out for the
      // current registration
      var cartItemIndex = _.findIndex(this.cart.current.items, function (item) {
        return _.isEqual(item, cartItem);
      });

      if (this.currentRegIncomplete(cartItemIndex)) {
        return;
      }

      // When clicking on a registration item, route to first attendee
      // for that registration by default.
      if (cartItem.registrants.length) {
        registrationNavigator.go(ATTENDEE_ROUTE, {
          cartItemId: cartItem.id,
          attendeeId: cartItem.registrants[0].id
        });
      } else {
        registrationNavigator.go(NEW_ATTENDEE_ROUTE, {
          cartItemId: cartItem.id
        });
      }
    };

    this.goToDonation = function () {
      registrationNavigator.go(DONATION_ROUTE);
    };

    this.goToSubitem = function (cartItemIndex, regIndex, event) {
      if ($state.is(TICKETS_ROUTE)) {
        return;
      }

      // Prevent cart item's onClick event from being called,
      // that will make us route twice.
      event.stopPropagation();

      var selectedItem = _.get(this.cart.current, ['items', cartItemIndex], false);
      var selectedReg = _.get(selectedItem, ['registrants', regIndex], false);
      if (this.currentRegIncomplete(cartItemIndex)) {
        return;
      }

      // If the selected registration doesn't exist at regIndex,
      // we'll be creating a new attendee
      if (!selectedReg) {
        registrationNavigator.go(NEW_ATTENDEE_ROUTE, {
          cartItemId: selectedItem.id
        });
      } else {
        registrationNavigator.go(ATTENDEE_ROUTE, {
          cartItemId: selectedItem.id,
          attendeeId: selectedItem.registrants[regIndex].id
        });
      }
    };

    this.isRequired = function (tag) {
      return _.get(_.find(_this2.questions, { tag: tag }), 'is_required', false);
    };

    // TICKETED: these check if there's a required custom Q for the registrants name/email
    // and apply it as part of the completeness
    this.isIncomplete = function (registrant) {
      return _this2.isRequired('first_name') && !registrant.first_name || _this2.isRequired('last_name') && !registrant.last_name || _this2.isRequired('email_address') && !registrant.email_address;
    };

    this.currentRegIncomplete = function (selectedItemIdx) {
      if (!$state.is(NEW_ATTENDEE_ROUTE) && !$state.is(ATTENDEE_ROUTE)) {
        return false;
      }

      // attendeeId param, will not exist if not given
      var currAttendeeId = $state.params.attendeeId;

      // info for the current item
      var currItemId = $state.params.cartItemId;
      var currItem = _.find(this.cart.stagedItems, function (item) {
        return item.id == currItemId;
      });
      var currItemInCart = _.find(this.cart.current.items, function (item) {
        return item.id == currItemId;
      });

      // info for the selected item (going to)
      var selectedItem = _.get(this.cart.current, ['items', selectedItemIdx], false);

      // last registrant in current item
      var lastReg = currItem.registrants[currItem.registrants.length - 1];

      // if we have n-1 registrants and n entries, we only have 1 more
      // BUT ALSO if the last
      var isLastReg = currItemInCart.entries - 1 == currItemInCart.registrants.length && !lastReg.id && !currAttendeeId;
      // if switching between items & the last registrant of this current item isn't done
      if (_.parseInt(selectedItem.id) !== _.parseInt(currItemId) && ((!lastReg.last_name || !lastReg.first_name || !lastReg.email_address) && this.HAS_FUNDRAISING || (this.isIncomplete(lastReg) || !isLastReg) && !this.HAS_FUNDRAISING)) {
        scFlowModalService.open({
          template: '\n              <modal-frame theme="\'dark\'"\n              role="dialog"\n              aria-labelledby="dialog_attendee_warning">\n                <modal-subtitle id="dialog_attendee_warning">\n                  Please complete all attendee forms for the current registration before continuing.\n                </modal-subtitle>\n                <div class="registration-cart__modal-btns">\n                  <button class="registration-cart__modal-dismiss"\n                  ng-click="$ctrl.closeModal()">\n                    Dismiss\n                  </button>\n                </div>\n              </modal-frame>\n            ',
          maxWidth: 396,
          transition: 'slideLeft',
          duration: 1000,
          context: $scope
        }, {
          elementToFocusOnClose: document.activeElement
        });
        return true;
      }

      return false;
    };

    this.closeModal = function () {
      scFlowModalService.close();
    };

    /* -------------------------------------------------------------------- *
     * Teams
     * -------------------------------------------------------------------- */

    this.showTeam = function () {
      return this.cart.current.team_name || this.cart.current.team_id;
    };

    this.teamName = function () {
      return this.team ? this.team.current.name : this.cart.current.team_name;
    };

    this.teamDetails = function () {
      var numItems = _.get(this, 'cart.stagedItems.length', 0);
      var text = 'Add some tickets to your cart to get started.';

      if (numItems > 1) {
        var totalAttendees = 0;
        _.forEach(this.cart.stagedItems, function (item) {
          totalAttendees += _.get(item, 'registrants.length', 0);
        });

        text = totalAttendees + ' attendees are joining this team.';
      } else if (numItems === 1) {
        if (_.get(this, 'cart.stagedItems[0].registrants.length', 1) == 1) {
          text = '1 attendee is joining this team';
        } else {
          text = this.cart.stagedItems[0].registrants.length + ' attendees are joining this team.';
        }
      }
      return text;
    };

    this.removeTeam = function () {
      this.cart.saveData({
        team_id: null,
        team_name: null,
        team_goal: null,
        team_description: null,
        team_answers: null
      });
    };

    /* -------------------------------------------------------------------- *
     * Tickets
     * -------------------------------------------------------------------- */

    this.itemCollection = function () {
      return this.cart.isReserved ? this.cart.current.items : this.cart.stagedItems;
    };

    this.itemName = function (item) {
      return _.find(this.ticketTypes, { id: item.product_id }).name;
    };

    this.itemPrice = function (item) {
      return _.find(this.ticketTypes, { id: item.product_id }).price;
    };

    this.itemCommitment = function (item) {
      return _.find(this.ticketTypes, { id: item.product_id }).commitment;
    };

    this.getAdjustedAmount = function (item) {
      var discount = this.itemPrice(item) - parseFloat(item.adjustment_amount);
      return Math.max(discount, 0);
    };

    this.itemDetails = function (item) {
      if (_.get(item, ['registrants', 0, 'first_name'])) {
        var firstName = item.registrants[0].first_name;
        var lastName = item.registrants[0].last_name || '';
        return firstName + ' ' + lastName;
      }
      return _.find(this.ticketTypes, { id: item.product_id }).description;
    };

    this.itemAttendees = function (index) {
      var stagedItem = _.get(this.cart, ['stagedItems', index]);
      return stagedItem ? stagedItem.registrants : [];
    };

    this.itemHighlighted = function (item) {
      return item.id === _.parseInt($state.params.cartItemId);
    };

    this.removeItem = function (item, event, index) {
      var _this3 = this;

      // Prevent cart item's onClick event from being called,
      // that will make us route twice.
      event.stopPropagation();

      // If we're removing the ONLY item in a reserved cart,
      // confirm with the user that they want to start over before actually removing it.
      if (this.cart.isReserved && this.cart.quantity <= 1) {
        this.removedItem = item;
        scFlowModalService.open({
          template: '\n                <restart-cart-modal\n                cart="$ctrl.cart"\n                item="$ctrl.removedItem"></restart-cart-modal>\n              ',
          context: $scope
        }, {
          elementToFocusOnClose: document.activeElement
        });
      } else {
        this.cart.unstageItem(item, index);

        if (this.cart.isReserved) {
          var donationFrequency = this.cart.current.donation_frequency;
          this.cart.removeItem(item).then(function () {
            // Need to reset donation frequency since reset timer removes it
            _this3.cart.current.donation_frequency = donationFrequency;
          });
          registrationNavigator.evacuate(item.id);
        }
      }
    };

    this.canRemoveItem = function () {
      return !this.cart.isErrored && !$state.is(PAYMENT_ROUTE);
    };

    // used to disable/enable the "jump to attendee #" button on ticketed events based on
    // if they have questions or not
    this.questionLock = function (item) {
      return !this.HAS_FUNDRAISING && !this.cart.itemHasQuestions(item);
    };

    /* -------------------------------------------------------------------- *
     * Donation
     * -------------------------------------------------------------------- */
    this.donationAmount = function () {
      return parseFloat(this.cart.current.donation_amount);
    };

    this.donationDetails = function () {
      var currentCreditee = this.cart.getCurrentRegistrantDonationCreditee();
      var frequencyText = _.capitalize(this.cart.current.donation_frequency);

      if (!currentCreditee) {
        return frequencyText + ' donation';
      }

      var firstName = currentCreditee.first_name,
          lastName = currentCreditee.last_name;

      return frequencyText + ' donation credited to ' + firstName + ' ' + lastName;
    };

    this.donationHighlighted = function () {
      return $state.is(DONATION_ROUTE);
    };

    this.removeDonation = function () {
      var _this4 = this;

      var savedDonationFreq = this.cart.current.donation_frequency;
      var savedDonationAmt = this.cart.current.donation_amount;

      this.cart.saveData({
        donation_amount: null,
        donation_frequency: null,
        donation_fee_on_top: null,
        donation_currency_code: null
      }).then(function () {
        var oldCreditee = _this4.cart.getCurrentRegistrantDonationCreditee();

        if (oldCreditee) {
          oldCreditee.donation_share = null;
          return _this4.cart.updateRegistrant(oldCreditee.id, { donation_share: null });
        }

        return Promise.resolve();
      }).then(function () {
        var currency = 'USD';
        if (scCampaignsService.active && scCampaignsService.active.current) {
          currency = scCurrencyService.getEntityCampaignCurrency(scCampaignsService.active.current);
        }

        _this4.cart.current.donation_frequency = savedDonationFreq;
        scAnalytics.eventBeacon({
          category: 'frs ' + scCampaignsService.active.current.type,
          action: 'remove',
          label: 'Remove from Cart',
          product_name: 'Additional Donation',
          price: savedDonationAmt,
          currency: currency
        });
      });
    };

    this.canRemoveDonation = function () {
      return !this.cart.isErrored;
    };
  }]
});
})();